import auth from "../../../../services/auth.js";
import Sales from "../../../../services/sales.js";
import vehicles from "../../../../services/vehicles.js";
import { cpfCnpj as cpfCnpjValidator } from "../../../../validators/cpfCnpj";
import FormModalNewSearch from "../form-modal/form-modal-new-search.vue";

export default {
  components: {
    "form-modal-new-search": FormModalNewSearch,
  },
  props: ["ArrayVehicles"],
  data() {
    return {
      // * Etapas do formulário
      stepForm: 0,

      // * Informações do veículo escolhido - Placa -
      plate: "",
      // * Informações do veículo escolhido - Nome da marca -
      brandName: "",
      // * Informações do veículo escolhido - Nome do modelo -
      modelName: "",
      // * Informações do veículo escolhido - Placa -
      arrayModelsByNetrin: [],
      // * Informações do veículo escolhido - Eixos -
      placeHolderFixed: "",
      axes: [],

      // * Condição booleana para mostrar o modal de confirmação
      modalConfirmVisibility: false,
      modalNewSearch: false,
      // * Condição booleana para mostrar o loading
      loading: false,
      // * Condição booleana para mostrar o dropdown dos eixos
      showAxes: false,
      axeIdSelected: undefined,
      axeNameSelected: undefined,
      plateAlreadyOn: false,
      netrimErrorBrands: [],
      axes: undefined,
      models: [],
      netrinOffVisibility: false,
      fipeId: undefined,
      categoryId: undefined,
      validatePlate: undefined,
      isMoto: undefined,

      // * RNTRC / Sou transportador
      souTransportador: false,
      cpfCnpjTransportador: "",
      anttStatus: null, // 'success' | 'error'
      anttLoading: false,
      mostrarAvisoAntt: false,
    };
  },

  watch: {
    axes: function (novoValor, valorAntigo) {},
  },

  computed: {
    // * Verdadeiro quando a placa foi totalmente digitada (7 caracteres)
    plateCompleta() {
      return this.plate.replace(/[^\w]/gi, "").length === 7;
    },
    // * Verdadeiro quando a placa está em formato válido (normal ou Mercosul)
    plateValida() {
      const placa = (this.plate || "").replace(/[^\w]/gi, "").toUpperCase();
      const regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
      const regexNormal = /^[A-Z]{3}[0-9]{4}$/;
      return regexMercosul.test(placa) || regexNormal.test(placa);
    },
    // * Placa digitada por completo mas em formato inválido → exibe erro
    plateInvalida() {
      return this.plateCompleta && !this.plateValida;
    },
    // * Transportador marcado mas ainda sem validação ANTT bem-sucedida
    transportadorPendente() {
      return this.souTransportador && this.anttStatus !== "success";
    },
    // * CPF ou CNPJ válido (dígitos verificadores) — habilita a consulta
    cpfCnpjValido() {
      return cpfCnpjValidator.validate(this.cpfCnpjTransportador || "");
    },
  },

  methods: {
    async getNetrimToken() {
      const resp = await auth.checkCpfValidationPermission();
      return resp && resp.token;
    },

    // * Funções para mostrar/remover os modais
    ShowModal() {
      return (this.modalConfirmVisibility = true);
    },

    VerificarPlaca() {
      let placa = this.plate.replace(/[^\w]/gi, "").toUpperCase();
      var regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
      var regexNormal = /^[A-Z]{3}[0-9]{4}$/;

      // Remover o hífen da placa, se presente
      placa = placa.replace("-", "");

      if (regexMercosul.test(placa)) {
        this.validatePlate = false;
      } else if (regexNormal.test(placa)) {
        this.validatePlate = false;
      } else {
        this.isMoto = false;
        this.validatePlate = true;
      }
    },

    CloseModalNewSearch() {
      this.modalNewSearch = false;
    },

    // * "Pesquisar novamente": fecha o modal e refaz a busca automaticamente
    // * com a placa já informada (RF-023 da US)
    refreshPage() {
      this.modalNewSearch = false;
      this.stepForm = 0;
      return this.NetrinValidation();
    },

    ShowNewSearch() {
      return (this.modalNewSearch = true);
    },
    // * "Cancelar" na confirmação: descarta o cadastro da placa em
    // * andamento e retorna o usuário para a etapa inicial (Etapa 30 da US)
    RemoveModal() {
      this.modalConfirmVisibility = false;
      this.netrinOffVisibility = false;
      this.resetVehicleForm();
      this.stepForm = 0;
      return;
    },

    // * Limpa todos os dados do veículo em preenchimento
    resetVehicleForm() {
      this.plate = "";
      this.brandName = "";
      this.modelName = "";
      this.arrayModelsByNetrin = [];
      this.models = [];
      this.netrimErrorBrands = [];
      this.axes = undefined;
      this.showAxes = false;
      this.axeIdSelected = undefined;
      this.axeNameSelected = undefined;
      this.placeHolderFixed = "";
      this.validatePlate = false;
      this.isMoto = false;
      this.plateAlreadyOn = false;
      this.souTransportador = false;
      this.cpfCnpjTransportador = "";
      this.anttStatus = null;
      this.mostrarAvisoAntt = false;
      this.emitTransportador();
      return;
    },

    // * Função para voltar 1 passo
    StepBack() {
      return (this.stepForm = 0);
    },

    // * Função para validar a placa na Netrin
    async NetrinValidation() {
      // Bloqueio: a placa precisa estar em formato válido para continuar
      if (!this.plateValida) {
        this.VerificarPlaca();
        return;
      }
      // Bloqueio: transportador marcado precisa validar na ANTT com sucesso
      if (this.transportadorPendente) {
        this.mostrarAvisoAntt = true;
        return;
      }
      this.mostrarAvisoAntt = false;

      this.VerificarPlaca();
      this.loading = true;
      this.plateAlreadyOn = false;

      let placaFormatada =
        this.plate.substring(0, 3) + "-" + this.plate.substring(3);

      if (!this.ArrayVehicles) this.ArrayVehicles = [];
      const filter = this.ArrayVehicles.findIndex(
        (element) =>
          element.plate == placaFormatada.toUpperCase() ||
          element.plate === this.plate.toUpperCase(),
      );

      if (filter != -1) {
        this.plateAlreadyOn = true;
        this.loading = false;
        return;
      }
      const VehicleExist = await vehicles.vehicleNotExists(placaFormatada);

      if (!VehicleExist) {
        this.loading = false;
        this.plateAlreadyOn = true;
        return;
      }
      let placa = this.plate.replaceAll("-", "");

      if (placa.length == 0) return (this.loading = false);
      if (
        placaFormatada.length >= 7 &&
        /^[a-zA-Z]{3}-[0-9][0-9a-jA-J][0-9]{2}$/.test(placaFormatada)
      ) {
        const netrimToken = await this.getNetrimToken();
        vehicles
          .getPlacaNetrim(placa, netrimToken)
          .then((data) => {
            if (data.isMoto > 0) {
              this.isMoto = true;
              this.loading = false;
              return;
            }

            this.arrayModelsByNetrin = data.modelos;
            this.arrayModelsByNetrin.forEach((element) => {
              element.caption = element.name;
              element.value = `${element.fipeId}|${element.modelId}`;
            });
            this.brandName = data.marcas[0].name;
            this.$emit(
              "ValueChanger",
              placaFormatada,
              data.marcas[0].name,
              data.marcas[0].brandId,
              this.arrayModelsByNetrin,
            );
            this.loading = false;
            this.stepForm = 1;
            return;
          })
          .catch(async (res) => {
            this.ShowNewSearch();
            const data = await vehicles.getVehicleBrand();
            this.netrimErrorBrands = data;
            this.netrimErrorBrands.forEach((element) => {
              element.caption = element.name;
              element.value = element.brandId;
            });
            this.stepForm = 404;
            this.loading = false;
          });
        return;
      }
      this.loading = false;
      return (this.showModalInvalidPlate = true);
    },

    async getModels(caption, value) {
      this.axes = "";
      const models = await vehicles.getVehicleModel(value);
      this.models = models;
      this.categoryId = models.categoryId;

      this.models.forEach((element) => {
        element.value = `${element.modelId}|${element.categoryId}`;
        element.caption = element.name;
      });
      this.brandName = caption;
      this.brandIdSelected = value;
      return;
    },
    async setModels(model, id) {
      var ArrayString = id.split("|");
      var fipeId = ArrayString[0];
      var categoryId = ArrayString[1];

      const netrimToken = await this.getNetrimToken();
      vehicles.listaEixosBase(categoryId, netrimToken).then((data) => {
        this.axes = data;
      });
      this.categoryId = categoryId;
      this.modelName = model;
      this.modelFipeIdSelected = fipeId;
      return;
    },
    setAxes(name, id) {
      this.axeNameSelected = name;
      this.axeIdSelected = id;
      this.$emit("AxesChanger", this.axeNameSelected, this.axeIdSelected);
      return;
    },
    showModal() {
      if (this.plate && this.modelName && this.brandName) {
        this.netrinOffVisibility = true;
      }
      return;
    },
    AddVehicleNetrimOff() {
      let placa = this.plate.replace(/[^\w]/gi, "").toUpperCase();
      var regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
      var regexNormal = /^[A-Z]{3}[0-9]{4}$/;

      // Remover o hífen da placa, se presente
      placa = placa.replace("-", "");

      if (regexMercosul.test(placa)) {
        this.validatePlate = false;
      } else if (regexNormal.test(placa)) {
        this.validatePlate = false;
      } else {
        this.validatePlate = true;
        return;
      }
      this.$emit(
        "ValueChangerNetrinOff",
        this.plate,
        this.brandName,
        this.brandIdSelected,
        this.modelName,
        this.modelFipeIdSelected,
      );
      this.modalConfirmVisibility = true;
      return;
    },

    // * Função para pegar os eixos do veículos de acordo com o modelo
    async getAxes(model, modelTeste) {
      this.axeIdSelected = "";
      this.axeNameSelected = "";

      var ArrayString = modelTeste.split("|");
      var fipeId = ArrayString[0];
      var modelId = ArrayString[1];

      this.disableAxes = false;
      this.loading = true;
      this.modelName = model;
      this.$emit("ModelChanger", model, modelId);
      const netrimToken = await this.getNetrimToken();
      vehicles
        .postAxes(this.brandName, model, fipeId, netrimToken)
        .then((data) => {
          let response = JSON.parse(data.consultado);
          if (response.listCategoryArtesp.length == 1) {
            this.placeHolderFixed = response.listCategoryArtesp[0].name;
            this.axeName = response.listCategoryArtesp[0].name;
            this.axeId = response.listCategoryArtesp[0].categoryArtespId;
            this.$emit(
              "AxesChanger",
              response.listCategoryArtesp[0].name,
              response.listCategoryArtesp[0].categoryArtespId,
            );
            this.axeIdSelected = response.listCategoryArtesp[0].name;
            this.axeNameSelected =
              response.listCategoryArtesp[0].categoryArtespId;
            this.disableAxes = true;
            this.loading = false;
            this.showAxes = true;
            return;
          }
          this.selectedModel = model;
          this.fipeId = fipeId;
          this.axes = response.listCategoryArtesp;
          this.axes.forEach((element) => {
            element.value = element.categoryArtespId;
            element.caption = element.name;
          });
          this.loading = false;
          this.showAxes = true;
          return;
        });
    },

    AddVehicle() {
      this.modalConfirmVisibility = false;
      this.plate = this.plate.substring(0, 3) + "-" + this.plate.substring(3);

      this.emitTransportador();
      this.$emit("SaveVehicle");
    },

    // * --------- RNTRC / Sou transportador --------- //

    // * Aplica máscara de CPF (000.000.000-00) ou CNPJ (00.000.000/0000-00)
    maskCpfCnpj(value) {
      let d = (value || "").replace(/\D/g, "").slice(0, 14);
      if (d.length <= 11) {
        return d
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      }
      return d
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
    },

    // * Dígitos do CPF/CNPJ do transportador
    cpfCnpjDigits() {
      return (this.cpfCnpjTransportador || "").replace(/\D/g, "");
    },

    // * Mantém a placa reativa a cada tecla (sem precisar sair do input)
    onPlateInput(event) {
      if (event && event.target) this.plate = event.target.value;
      this.corrigeMascara();
      // Ao editar a placa, limpa erros de placa de tentativas anteriores
      this.validatePlate = false;
      this.isMoto = false;
      this.plateAlreadyOn = false;
      // Mudar a placa invalida o transportador: desmarca o checkbox,
      // limpa o CPF/CNPJ e apaga a consulta ANTT já realizada.
      if (
        this.souTransportador ||
        this.cpfCnpjTransportador ||
        this.anttStatus
      ) {
        this.souTransportador = false;
        this.cpfCnpjTransportador = "";
        this.anttStatus = null;
        this.mostrarAvisoAntt = false;
        this.emitTransportador();
      }
    },

    // * Ao marcar/desmarcar o checkbox de transportador
    onTransportadorToggle() {
      if (!this.souTransportador) {
        this.cpfCnpjTransportador = "";
        this.anttStatus = null;
      }
      this.mostrarAvisoAntt = false;
      this.emitTransportador();
    },

    // * Ao digitar o CPF/CNPJ: aplica máscara e invalida consulta anterior
    onCpfCnpjInput() {
      this.cpfCnpjTransportador = this.maskCpfCnpj(this.cpfCnpjTransportador);
      this.anttStatus = null;
      this.mostrarAvisoAntt = false;
      this.emitTransportador();
    },

    // * Consulta o RNTRC do transportador na ANTT
    consultarAntt() {
      const transportador = this.cpfCnpjDigits();
      const placa = this.plate.replace(/[^\w]/gi, "").toUpperCase();

      if (!transportador || !placa) {
        this.anttStatus = "error";
        return;
      }

      this.anttLoading = true;
      Sales.consultarRNTRC(transportador, [placa])
        .then((resp) => {
          this.anttStatus = this.anttRespostaValida(resp, placa)
            ? "success"
            : "error";
          if (this.anttStatus === "success") this.mostrarAvisoAntt = false;
          this.anttLoading = false;
          this.emitTransportador();
        })
        .catch(() => {
          this.anttStatus = "error";
          this.anttLoading = false;
          this.emitTransportador();
        });
    },

    // * Sucesso só com RNTRC ativo e a placa na frota ativa (regras ANTT)
    anttRespostaValida(resp, placa) {
      if (!resp || (resp.status && resp.status.code)) return false;
      if (resp.rntrcAtivo !== true) return false;
      if (!Array.isArray(resp.frota)) return false;
      const norm = (p) => (p || "").replace(/[^\w]/gi, "").toUpperCase();
      return resp.frota.some(
        (f) =>
          norm(f.placaVeiculo) === placa &&
          f.situacaoVeiculoFrotaTransportador === true,
      );
    },

    // * Informa o pai os dados de transportador do veículo atual
    emitTransportador() {
      this.$emit(
        "TransportadorChanger",
        this.souTransportador,
        this.cpfCnpjDigits(),
      );
    },

    PlateFormat(plate) {
      let NewPlate = plate.substring(0, 3) + "-" + plate.substring(3);
      let result = NewPlate;
      let placa = NewPlate.replaceAll("-", "");
      if (/^[A-Za-z]+$/.test(NewPlate[5])) result = placa;

      return result;
    },

    verificarTecla(event) {
      if (event.keyCode === 189) {
        // Código do hífen
        event.preventDefault();
      }
    },

    corrigeMascara() {
      this.$nextTick(() => {
        //para o cursor continuar no final do input
        $("#plate").val($("#plate").val());
      });
    },

    tratarTextoColado(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      let text = clipboardData.getData("text/plain");
      text = text.replace(/-/g, "");
      event.preventDefault();

      // Adicione aqui qualquer outra manipulação necessária ao texto colado
      document.execCommand("insertText", false, text);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Pages/Adhesion/FormVehicle/FormVehicle.js